import * as React from 'react';
import {useState} from 'react';
import classNames from 'classnames';

import './style.scss';

import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';
import {Icon} from 'components/atoms/Media/Icon';
import {ResidenceCardData} from "features/search/types";

import {useFavorite} from "features/authentication/services/FavoritesService/useFavorite";
import {useAuth} from "features/authentication/hooks/useAuth";

interface Props {
    className?: string;
    small?: boolean;
    residence: ResidenceCardData;
}

export const FavoriteButton: React.FunctionComponent<Props> = ({className, small, residence}) => {
    const {user} = useAuth();
    const {active, toggleFavorite} = useFavorite(residence);
    const [animating, _setAnimating] = useState<boolean>(false);
    
    if (user?.isLegalEntity) return null;

    const onClick = () => {
        toggleFavorite();
    };

    const buttonClasses = classNames('favorite-button', className, {
        'favorite-button--small': small,
        'favorite-button--active': active,
        'favorite-button--animating': animating,
    });

    return (
        <Button
            id={'favoriteBtn-' + residence.id}
            className={buttonClasses}
            onClick={onClick}
            preventDefault
            icon={<Icon name={active ? 'favorite-filled' : 'favorite'} />}
            iconBtn
            buttonColor={ButtonColor.LIGHT} 
            buttonSize={small ? ButtonSize.SMALL : ButtonSize.DEFAULT} 
            buttonType={ButtonType.DEFAULT}
        >
            Favoritmarkering
        </Button>
    )
};
